import img1 from '../../assets/images/banner8.jpg';
import img2 from '../../assets/images/banner2.jpg';
import PageBanner from '../common/PageBanner';

function BannerEvents() {
  const slides = [
    {
      image: {
        src: img1
      },
      html: (
        <div className="h-full flex align-items-center jc-center">
          <h1 className="ff-space-grotesk text-center text-white fs-600 lh-600 pt-500 p-md-none">Events</h1>
        </div>
      )
    },
    {
      image: {
        src: img2
      },
      html: (
        <div className="h-full flex align-items-center jc-center">
          <h1 className="ff-space-grotesk text-center text-white fs-600 lh-600 pt-500 p-md-none">Events</h1>
        </div>
      )
    }
  ];

  return <PageBanner slides={slides} />;
}

export default BannerEvents;
